<template>
  <v-container>
    <v-form entype="multipart/form-data" ref="form">
      <v-file-input ref="file" v-model="upload" label="FileInput" />
      <v-text-field v-model="name" label="Name" prepend-icon="note"/>
      <div class="d-flex justify-end">
        <v-btn @click="submit()" text color="green">
          <v-icon left>cloud_upload</v-icon>
          Submit
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { BatchAttachment } from "../../models/Attachment";
export default {
  name: "BatchAttachmentForm",
  props: {
    id: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data() {
    return {
      name: "",
      upload: []
    };
  },
  methods: {
    submit() {
      const formData = new FormData();
      formData.append("upload", this.upload);
      formData.append("name", this.name);
      formData.append("batch", this.id);
      BatchAttachment.$post(formData)
        .then(() => {
          this.clear();
        });
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

